import { connectProtectedEventPage } from '../containers/protectedEvent/connectProtectedEventPage';
import ProtectedEventPage from '../containers/protectedEvent/ProtectedEventPage';

export default connectProtectedEventPage(ProtectedEventPage);
